import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map } from 'immutable';

import FormGroup from '../helpers/FormGroup';
import { AutoSuggestion } from '../helpers/AutoSuggestion';
import FieldError from '../helpers/FieldError';

/**
 * User auto-suggestion component.
 *
 * @param props {Object}.
 * @param props.name {string} Name of text control.
 * @param props.label {string} Label of text control.
 * @param props.formMode {function} Form mode (view|edit).
 * @param props.formError {Immutable.Map} Error on form.
 * @param props.selectedUser {Immutable.Map} Selected user.
 * @param props.onSuggestionClose {function} Handle to close suggestion.
 */
const UserAutocompleteComponent = ({
  id,
  name,
  label,
  formMode,
  formError,
  selectedUser,
  suggestions,
  mode,
  onSuggestionInputClick,
  onSuggestionSelect,
  onSuggestionClose,
  onBlur,
}) => {
  const error = formMode === 'edit' ? formError.get(name, '') : '';

  return (
    <FormGroup className={error ? 'has-error' : ''}>
      <label htmlFor={id}>{label}</label>
      <AutoSuggestion
        data={{ name }}
        disabled={formMode === 'view'}
        id={id}
        label={label}
        mode={mode}
        name={name}
        onBlur={onBlur}
        onSuggestionClose={onSuggestionClose}
        onSuggestionInputClick={onSuggestionInputClick}
        onSuggestionSelect={onSuggestionSelect}
        suggestions={suggestions}
        value={selectedUser.get(name)}
      />
      <FieldError message={error} />
    </FormGroup>
  );
};

UserAutocompleteComponent.propTypes = {
  formError: PropTypes.instanceOf(Map).isRequired,
  formMode: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSuggestionClose: PropTypes.func.isRequired,
  onSuggestionSelect: PropTypes.func.isRequired,
  selectedUser: PropTypes.instanceOf(Map).isRequired,
  suggestions: PropTypes.instanceOf(List).isRequired,
};

export const UserAutocomplete = memo(UserAutocompleteComponent);
